<script lang="ts">
  import Scale from '../../uTheory.Notation/scale';
  import SolfegePanel from '../solfegePanel/SolfegePanel.svelte';
  import { getSolfegeSystemsMapForScaleMode } from '../getSolfegeSystemsMapForScaleMode';
  import sizeDiv from '../sizeDiv';
  import type { ScaleDegree } from '../solfegeDefinitions';

  import type SolfegeScaleDegreeHandSignMultipleChoice from './solfegeScaleDegreeHandSignMultipleChoice';

  export let interactive: SolfegeScaleDegreeHandSignMultipleChoice;
  export let gameOver = false;
  export let disabled = false;

  const questionSystem = interactive.options.presentationSystemForQuestions;
  const answerSystem = interactive.options.presentationSystemForAnswers;
  const solfegeSystem = interactive.solfegeSystem;
  const solfegeSystemString = solfegeSystem === 'solfegeLaMinor' ? 'la minor' : 'do minor';
  const mode = interactive.options.mode || 'Major';
  const { scaleDegrees, handSigns, solfege } = getSolfegeSystemsMapForScaleMode(
    mode,
    solfegeSystem,
  );

  let answerSystemString = 'scale degree';
  if (answerSystem === 'handSigns') answerSystemString = 'hand sign';
  if (answerSystem === 'solfege') answerSystemString = 'solfege';

  const scale = new Scale('C', mode);
  const readableModeName =
    scale.modeToString() + (mode.includes('Melodic') ? ` ${scale.directionToString()}` : '');

  /** The scale degree of the current question */
  let currentScaleDegree: string;
  let currentSolfege: string;
  let currentHandSign: typeof handSigns[number];

  export function newQuestion(scaleDegree: ScaleDegree) {
    console.log('new question', scaleDegree);
    const sdIndex = scaleDegrees.findIndex((d) => d.name === scaleDegree);
    if (sdIndex === -1) {
      throw Error(`${scaleDegree} is not a valid scale degree in ${mode}`);
    }
    currentScaleDegree = scaleDegree;
    currentSolfege = solfege[sdIndex]!;
    currentHandSign = handSigns[sdIndex]!;
  }

  let emptyWidthDiv: HTMLDivElement;
  let gameBoardDiv: HTMLDivElement;

  export function resize(height: number): number {
    console.log('resizing');
    if (!emptyWidthDiv || !gameBoardDiv) return 0;
    const leftover = sizeDiv(emptyWidthDiv.clientWidth, height, gameBoardDiv, { noWrap: true });
    gameBoardDiv.style.height = 'auto';
    return leftover;
  }
</script>

<div bind:this={emptyWidthDiv} />
<div class="game-board" bind:this={gameBoardDiv}>
  {#if currentScaleDegree && !gameOver}
    <h2 class="h2" aria-live="assertive">
      <span class="small-title">What {answerSystemString} is:</span>
      {#if questionSystem === 'solfege'}
        {currentSolfege}
      {:else if questionSystem === 'scaleDegrees'}
        {currentScaleDegree}
      {:else if questionSystem === 'handSigns'}
        {@html currentHandSign.svgString}
      {/if}
      <!-- Don't show "in mode" if we're just identifying handsign to solfege -->
      {#if questionSystem === 'scaleDegrees' || answerSystem === 'scaleDegrees'}
        <span class="small-title"
          >in
          {#if mode !== 'Major'}
            {readableModeName} ({solfegeSystemString})
          {:else}
            Major
          {/if}?</span
        >
      {/if}
    </h2>
    <SolfegePanel
      presentationSystem={answerSystem}
      {mode}
      bind:disabled
      callback={(sd) => interactive.checkAnswer(sd)}
    />
  {/if}

  {#if gameOver}
    <h2>Nice work!</h2>
  {/if}
</div>

<style>
  .game-board {
    text-align: center;
    font-size: 2em;
    padding: 7px;
  }

  .buttons {
    display: grid;
    grid-template: repeat(2, 1fr) / repeat(4, 1fr);
  }

  .button {
    font-size: 2em;
    padding-top: 20px;
  }

  .button > svg {
    padding: 10px;
  }

  .small-title {
    display: block;
    font-size: 0.5em;
  }

  .h2 {
    font-size: 2em;
    text-align: center;
    line-height: unset;
  }
</style>
